/*eslint-disable*/
import React, { useEffect, useState, useRef } from "react";
import { decode as base64_decode, encode as base64_encode } from "base-64";
import PropTypes from "prop-types";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { headApi } from "utils/headApi";
import { localApi, credentials } from "utils/headApi";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
// import Icon from "@material-ui/core/Icon";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Apps from "@material-ui/icons/Apps";
import { FaUserEdit, FaExpeditedssl, FaAddressBook } from "react-icons/fa";
import { IoFingerPrintSharp } from "react-icons/io5"; //IoBagAddOutline
import { IoMdLogOut } from "react-icons/io";
import { RiShoppingBagLine } from "react-icons/ri";
import { MdAddchart } from "react-icons/md";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import { FiPhoneCall } from "react-icons/fi";
import Close from "@material-ui/icons/Close";
// import InputAdornment from "@material-ui/core/InputAdornment";
import Slide from "@material-ui/core/Slide";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import NavPills from "components/NavPills/NavPills.js";
import EmailIcon from "@material-ui/icons/Email";
import PhoneAndroidIcon from "@material-ui/icons/PhoneAndroid";
import CardFooter from "components/Card/CardFooter.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import CustomDropdown from "components/CustomDropdown/CustomDropdown.js";
import Button from "components/CustomButtons/Button.js";
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";
import SweetAlert from "react-bootstrap-sweetalert";

import styles from "assets/jss/material-kit-pro-react/components/inshaheaderLinkStyle.js";
import javascriptStyles from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.js";
import headersStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.js";
// import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import styleSweet from "assets/jss/material-kit-pro-react/components/buttonStyle.js";

const CLIENT_ID =
  "470676783464-l79og9cvikh9vb5019o261e5h7ak8krm.apps.googleusercontent.com";
const SCOPES = "https://www.googleapis.com/auth/contacts.readonly";

import { cardTitle } from "assets/jss/material-kit-pro-react.js";

const style = {
  cardTitle,
  pageSubcategoriesTitle: {
    color: "#3C4858",
    textDecoration: "none",
    textAlign: "center",
  },
  cardCategory: {
    margin: "0",
    color: "#999999",
  },
};

const useStyles = makeStyles(styles);
const useStyle = makeStyles(javascriptStyles);
const useStyl = makeStyles(headersStyle);
const useSty = makeStyles(style);
const useStyleAlert = makeStyles(styleSweet);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function InshaHeaderLink(props) {
  const [bangle, setbangle] = React.useState([]);
  const [earing, setEaring] = React.useState([]);
  const [ring, setRing] = React.useState([]);
  const [watch, setWatch] = React.useState([]);
  const [kada, setKada] = React.useState([]);
  const [loginModal, setLoginModal] = React.useState(false);
  const [mobile, setMobile] = React.useState("");
  const [mobileErr, setMobileErr] = React.useState("");
  const [otpNumber, setOtpNumber] = React.useState("");
  const [otpNumberErr, setOtpNumberErr] = React.useState("");
  const [otpScreen, setOtpScreen] = React.useState(false);
  const [otp, setOtp] = React.useState("");
  const [cardList, setCardList] = React.useState([]);

  const [reSend, setReSend] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [emailErr, setEmailErr] = React.useState("");
  const [admin, setAdmin] = React.useState([]);

  const [emailConfirm, setEmailConfirm] = React.useState("");
  const [emailConfirmErr, setEmailConfirmErr] = React.useState("");

  const [otpMpin, setOtpMpin] = React.useState("");
  const [forgotPass, setForgotPass] = React.useState(false);
  const [otpConfirm, setOtpConfirm] = React.useState(false);
  const [updatePassword, setUpdatePassword] = React.useState(false);

  const [accessToken, setAccessToken] = React.useState(null);
  const [contacts, setContacts] = React.useState([]);
  const [error, setError] = React.useState("");
  const [scriptLoaded, setScriptLoaded] = React.useState(false);

  const timerRef = useRef(null);
  const timeout = 10 * 60 * 1000; // 10 minutes

  const [password, setPassword] = useState(["", "", "", "", "", ""]);
  const [passwordErr, setPasswordErr] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState([
    "",
    "",
    "",
    "",
    "",
    "",
  ]);
  const [passwordConfirmErr, setPasswordConfirmErr] = useState("");
  const [updatePasswordConfirm, setUpdatePasswordConfirm] = useState([
    "",
    "",
    "",
    "",
    "",
    "",
  ]);
  const [updatePasswordConfirmErr, setUpdatePasswordConfirmErr] = useState("");

  const [submitted, setSubmitted] = React.useState(false);
  const [alertMsg, alertMsgOps] = React.useState("");
  const [alertType, alertTypeOps] = React.useState("");

  // ✅ Refs - separate for each section
  const inputs = useRef([]); // Login / OTP input refs
  const inputsConfirm = useRef([]); // Confirm Code input refs
  const inputsUpdate = useRef([]); // Update mPIN input refs

  // Initialize refs only once
  useEffect(() => {
    inputs.current = Array(6)
      .fill()
      .map((_, i) => inputs.current[i] || React.createRef());
    inputsConfirm.current = Array(6)
      .fill()
      .map((_, i) => inputsConfirm.current[i] || React.createRef());
    inputsUpdate.current = Array(6)
      .fill()
      .map((_, i) => inputsUpdate.current[i] || React.createRef());
  }, []);

  const loadGoogleScript = () => {
    if (scriptLoaded || window.google?.accounts?.oauth2) {
      setScriptLoaded(true);
      return;
    }

    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    script.onload = () => {
      setScriptLoaded(true);
    };
    document.body.appendChild(script);
  };

  const { dropdownHoverColor } = props;
  const classes = useStyles();
  const classPop = useStyle();
  const classHeader = useStyl();
  const history = useHistory();
  const classe = useStyl();
  const classeAlert = useStyleAlert();

  // const date = Intl.DateTimeFormat("fr-CA", {
  //   year: "numeric",
  //   month: "numeric",
  //   day: "numeric",
  // })
  //   .format(new Date())
  //   .replaceAll("/", "-");

  const activeSession = sessionStorage.getItem("sessionData");
  const userObj = JSON.parse(sessionStorage.getItem("sessionData"));
  const userLocation = JSON.parse(sessionStorage.getItem("userLocation"));

  // 🔔 Listen for global "openLoginModal" event
  useEffect(() => {
    // ✅ Check if login should open automatically (from redirect)
    if (sessionStorage.getItem("triggerLogin") === "true") {
      setLoginModal(true);
      sessionStorage.removeItem("triggerLogin");
    }
  }, []);

  // ✅ Password change handlers
  const handlePasswordChange = (text, index) => {
    if (/^\d?$/.test(text)) {
      const updated = [...password];
      updated[index] = text;
      setPassword(updated);

      if (text && index < 5) {
        inputs.current[index + 1] && inputs.current[index + 1].focus();
      }
    }
  };

  const handleKeyPress = (e, index) => {
    if (e.key === "Backspace" && !password[index] && index > 0) {
      inputs.current[index - 1] && inputs.current[index - 1].focus();
    }
  };

  // ✅ Confirm Code handlers
  const handlePasswordChangeConfirm = (text, index) => {
    if (/^\d?$/.test(text)) {
      const updated = [...passwordConfirm];
      updated[index] = text;
      setPasswordConfirm(updated);

      if (text && index < 5) {
        inputsConfirm.current[index + 1] &&
          inputsConfirm.current[index + 1].focus();
      }
    }
  };

  const handleKeyPressConfirm = (e, index) => {
    if (e.key === "Backspace" && !passwordConfirm[index] && index > 0) {
      inputsConfirm.current[index - 1] &&
        inputsConfirm.current[index - 1].focus();
    }
  };

  // ✅ Update Password handlers
  const handlePasswordChangeConfirmUpdate = (text, index) => {
    if (/^\d?$/.test(text)) {
      const updated = [...updatePasswordConfirm];
      updated[index] = text;
      setUpdatePasswordConfirm(updated);

      if (text && index < 5) {
        inputsUpdate.current[index + 1] &&
          inputsUpdate.current[index + 1].focus();
      }
    }
  };

  const handleKeyPressConfirmUpdate = (e, index) => {
    if (e.key === "Backspace" && !updatePasswordConfirm[index] && index > 0) {
      inputsUpdate.current[index - 1] &&
        inputsUpdate.current[index - 1].focus();
    }
  };

  useEffect(() => {
    const fetchAdminData = async () => {
      try {
        const response = await fetch(localApi + `/admin/allList`, {
          method: "GET",
          headers: {
            Authorization: `Basic ${credentials}`,
          },
        });
        const json = await response.json();
        setAdmin(json.AdminList);
      } catch (error) {
        console.log("error", error);
      }
    };

    fetchAdminData();
  }, []);

  useEffect(() => {
    if (!userObj || !userObj.id || !userObj.admin?.id) return;

    const fetchCartListData = async () => {
      try {
        const response = await fetch(localApi + `/clientGroup/allList`, {
          method: "GET",
          headers: {
            Authorization: `Basic ${credentials}`,
          },
        });

        const json = await response.json();

        if (!json?.ClientList?.length) {
          console.warn("ClientList empty or missing");
          return;
        }

        const cList = json.ClientList?.find((f) => f.regId === userObj.id);

        if (!cList) {
          console.warn("No client found for regId:", userObj.id);
          return;
        }

        const list =
          localApi +
          `/cart/expireCart/byAdminAndClientIdAndAcitve/${userObj.admin.id}/${cList.id}?active=0`;

        const result = await fetch(list, {
          method: "GET",
          headers: {
            Authorization: `Basic ${credentials}`,
          },
        });

        const data = await result.json();
        setCardList(data || []);
      } catch (error) {
        console.log("error", error);
      }
    };

    fetchCartListData();
  }, [userObj]);

  // const handleMobileNumber = (mobile) => {
  //   setMobile(mobile);
  //   // setMobileErr("");
  //   fetch(localApi + `/register/find/byMobile/${mobile}`, {
  //     method: "GET",
  //     headers: {
  //       Authorization: `Basic ${credentials}`,
  //     },
  //   })
  //     .then((res) => res.json())
  //     .then(
  //       (result) => {
  //         // console.log(result);
  //         // setMobileErr(result.message);
  //         if (result.message === "Mobile No. Already Registered") {
  //           setMobileErr("");
  //         } else if (result.message === "Not Found") {
  //           setMobileErr("Your No. Not Registered");
  //         } else {
  //           setMobileErr(result.message);
  //         }
  //       },
  //       (error) => {
  //         console.log(error);
  //       }
  //     );
  // };

  const PHONE_RULES = {
    in: 12, // India 91 + 10
    us: 11, // USA 1 + 10
    ca: 11, // Canada
    mx: 12, // Mexico
    br: 13, // Brazil
    ar: 12, // Argentina

    uk: 12, // United Kingdom 44 + 10
    fr: 11, // France
    de: 12, // Germany
    it: 12, // Italy
    es: 12, // Spain
    nl: 11, // Netherlands
    be: 11, // Belgium
    ch: 11, // Switzerland
    at: 11, // Austria
    se: 11, // Sweden
    no: 11, // Norway
    dk: 10, // Denmark
    fi: 11, // Finland
    ie: 11, // Ireland
    pt: 12, // Portugal
    pl: 11, // Poland
    cz: 12, // Czech
    hu: 11, // Hungary
    ro: 12, // Romania
    bg: 12, // Bulgaria
    gr: 12, // Greece
    ru: 11, // Russia
    ua: 12, // Ukraine

    ae: 12, // UAE 971 + 9
    sa: 12, // Saudi Arabia
    qa: 11, // Qatar
    kw: 11, // Kuwait
    om: 11, // Oman
    bh: 11, // Bahrain
    jo: 12, // Jordan
    lb: 11, // Lebanon
    il: 12, // Israel
    tr: 12, // Turkey
    ir: 12, // Iran
    iq: 13, // Iraq

    cn: 13, // China
    jp: 11, // Japan
    kr: 11, // South Korea
    sg: 10, // Singapore
    my: 11, // Malaysia
    th: 11, // Thailand
    id: 12, // Indonesia
    ph: 12, // Philippines
    vn: 11, // Vietnam
    hk: 11, // Hong Kong
    tw: 11, // Taiwan

    au: 11, // Australia
    nz: 11, // New Zealand

    za: 11, // South Africa
    ng: 13, // Nigeria
    ke: 12, // Kenya
    eg: 12, // Egypt
    ma: 12, // Morocco
    gh: 12, // Ghana
  };

  const handleMobileNumber = (mobile, country) => {
    setMobile(mobile);
    setMobileErr("");

    const rule = PHONE_RULES[country];

    // ❌ stop API calls for incomplete numbers
    if (!rule || mobile.length !== rule.totalLength) {
      return;
    }

    fetch(localApi + `/register/find/byMobile/${mobile}`, {
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    })
      .then(async (res) => {
        if (res.status === 404) {
          setMobileErr("Your No. Not Registered");
          return null; // ⛔ stop here
        }
        if (!res.ok) {
          throw new Error("Server Error");
        }
        return res.json();
      })
      .then((result) => {
        if (!result) return;
        if (result.message === "Mobile No. Already Registered") {
          setMobileErr("");
        }
      })
      .catch((err) => console.log(err));
  };

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
  };

  const handleEmail = (e) => {
    const value = e.target.value;
    setEmail(value);
    setEmailErr("");

    // 🔴 empty field
    if (!value) {
      setEmailErr("Email is required");
      return;
    }

    // 🔴 invalid format
    if (!isValidEmail(value)) {
      setEmailErr("Please enter a valid email address");
      return;
    }

    fetch(localApi + `/register/find/byEmail/${value}`, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    })
      .then(async (res) => {
        if (res.status === 404) {
          setEmailErr("Your Email Not Registered");
          return null;
        }
        if (!res.ok) {
          throw new Error("Server Error");
        }
        return res.json();
      })
      .then((result) => {
        if (!result) return;

        if (result.message === "Email ID Already Registered") {
          setEmailErr("");
        }
      })
      .catch((error) => console.log(error));
  };

  const handleEmailConfirm = (e) => {
    const { value } = e.target;
    setEmailConfirm(value);

    // ❌ stop if empty
    if (!value) return;

    // ❌ stop if invalid email format
    if (!isValidEmail(value)) {
      setEmailConfirmErr("Please enter a valid email address");
      return;
    }

    if (value) {
      fetch(localApi + `/register/find/byEmail/${value}`, {
        method: "GET",
        headers: {
          Authorization: `Basic ${credentials}`,
        },
      })
        .then(async (res) => {
          // ✅ prevent 404 console error
          if (res.status === 404) {
            return { message: "Not Found" };
          }
          return res.json();
        })
        .then((result) => {
          // 🔁 SAME conditions as your original code
          if (result.message === "Email ID Already Registered") {
            setEmailConfirmErr("");
          } else if (result.message === "Not Found") {
            setEmailConfirmErr("Your Email Not Registered");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const handleOtp = (e) => {
    // console.log(e.target.value);
    setOtpNumber(e.target.value);
    setOtpNumberErr("");
  };

  const handleSendOtpWithMobile = async () => {
    // console.log("okkkk");
    const getFindAdmin = admin?.find(
      (f) => f.websitename === "indianbangles.in",
    );
    const api = localApi + `/register/byMobile/${mobile}`;
    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResult = await result.json();
    let errorCount = 0;
    if (mobile === "" || !mobile) {
      errorCount++;
      setMobileErr("Mobile Number is Invalid");
    }
    if (errorCount === 0) {
      fetch(
        localApi +
          `/otp/send/byMobile?mobile=${mobile}&templateID=1207161762762132153`,
        {
          method: "PUT",
          headers: {
            "content-type": "application/json",
            accept: "application/json",
            Authorization: `Basic ${credentials}`,
          },
          body: JSON.stringify({
            websitename: "indianbangles.in",
            followId: getFindAdmin.id,
            adminId: getResult.aId,
          }),
        },
      )
        .then((response) => response.json())
        .then((response) => {
          // console.log(response);
          setMobileErr(response.message);
          if (response && response.error === true) {
            setOtpScreen({ otpScreen: true });
            setOtp(response.message);
            setOtpMpin("OTP");
          }
          // "Sender Not Found to +919967457786"
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleSendPasswordWithMobile = async () => {
    const getFindAdmin = Array.isArray(admin)
      ? admin.find((f) => f.websitename === "indianbangles.in")
      : null;

    if (!getFindAdmin?.id) {
      setMobileErr("Admin not found");
      return;
    }

    if (!mobile) {
      setMobileErr("Mobile Number is Invalid");
      return;
    }

    try {
      const api = localApi + `/register/byMobile/${mobile}`;
      const result = await fetch(api, {
        method: "GET",
        headers: {
          Authorization: `Basic ${credentials}`,
        },
      });

      const getResult = await result.json();

      await fetch(
        localApi +
          `/register/password/send/byMobile?mobile=${mobile}&templateID=1207161762762132153`,
        {
          method: "PUT",
          headers: {
            "content-type": "application/json",
            accept: "application/json",
            Authorization: `Basic ${credentials}`,
          },
          body: JSON.stringify({
            websitename: "indianbangles.in",
            followId: getFindAdmin.id,
            adminId: getResult?.aId,
          }),
        },
      )
        .then((res) => res.json())
        .then((response) => {
          setMobileErr(response.message);
          if (response?.error === true) {
            setOtpScreen({ otpScreen: true });
            setOtp(response.message);
            setOtpMpin("mPIN");
          }
        });
    } catch (err) {
      console.log("Send password error:", err);
    }
  };

  const handleSendOtpWithEmail = async () => {
    if (!scriptLoaded && !window.google?.accounts?.oauth2) {
      loadGoogleScript();
      setTimeout(() => {
        startLogin(); // Slight delay to ensure script loads
      }, 500);
    } else {
      startLogin();
    }

    const getFindAdmin = admin?.find(
      (f) => f.websitename === "indianbangles.in",
    );
    // console.log(getFindAdmin);

    const api = localApi + `/register/byEmail/${email}`;
    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResult = await result.json();

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Basic ${credentials}`,
      },
      body: JSON.stringify({
        to: email,
        subject: "API CREATION SUBJECT",
        websitename: "indianbangles.in",
        followId: getFindAdmin.id,
        adminId: getResult.aId,
      }),
    };
    fetch(
      localApi + `/otp/send/byEmail?e=noreply@indianbangles.in`,
      requestOptions,
    )
      .then((response) => response.json())
      .then((response) => {
        // console.log(response);
        setEmailErr(response.message);
        if (response && response.error === true) {
          setOtpScreen({ otpScreen: true });
          setOtp(response.message);
          setOtpMpin("OTP");
        }
        // "Sender Not Found to +919967457786"
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleLoginWithMobile = () => {
    let errorCount = 0;
    const passwordString = password.join("");
    if (
      passwordString === "" ||
      !passwordString ||
      passwordString.length !== 6
    ) {
      errorCount++;
      setOtpNumberErr("OTP must be exactly 6 digits.");
    }
    if (errorCount === 0) {
      fetch(
        localApi +
          `/register/recieved/byMobile?mobile=${mobile}&otp=${passwordString}`,
        {
          method: "PUT",

          headers: {
            "content-type": "application/json",
            accept: "application/json",
            Authorization: `Basic ${credentials}`,
          },
        },
      )
        .then((response) => response.json())
        .then((response) => {
          // console.log(response);
          setOtpNumberErr(response.message);
          if (response.errorDetails.error === true) {
            const userObj = response.registerSession;
            localStorage.setItem("userObj", JSON.stringify(userObj));
            sessionStorage.setItem("sessionData", JSON.stringify(userObj));
            history.push("/product-list");
          }
          // if (response.apiResponse.error !== "false") return false;
          // const userObj = response.user;
          // localStorage.setItem("userObj", JSON.stringify(userObj));
          // sessionStorage.setItem("sessionData", JSON.stringify(userObj));
          // history.push("/admin/dashboard");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleLoginWithMobilePassword = () => {
    let errorCount = 0;
    const passwordString = password.join("");
    if (
      passwordString === "" ||
      !passwordString ||
      passwordString.length !== 6
    ) {
      errorCount++;
      setOtpNumberErr("OTP must be exactly 6 digits.");
    }
    if (errorCount === 0) {
      fetch(
        localApi +
          `/register/recieved/byMobilePassword?mobile=${mobile}&password=${passwordString}`,
        {
          method: "PUT",
          headers: {
            "content-type": "application/json",
            accept: "application/json",
            Authorization: `Basic ${credentials}`,
          },
        },
      )
        .then((response) => response.json())
        .then((response) => {
          // console.log(response);
          setOtpNumberErr(response.message);
          if (response.errorDetails.error === true) {
            const userObj = response.registerSession;
            localStorage.setItem("userObj", JSON.stringify(userObj));
            sessionStorage.setItem("sessionData", JSON.stringify(userObj));
            history.push("/product-list");
          }
          // if (response.apiResponse.error !== "false") return false;
          // const userObj = response.user;
          // localStorage.setItem("userObj", JSON.stringify(userObj));
          // sessionStorage.setItem("sessionData", JSON.stringify(userObj));
          // history.push("/admin/dashboard");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleLoginWithEmail = () => {
    let errorCount = 0;
    const passwordString = password.join("");
    if (
      passwordString === "" ||
      !passwordString ||
      passwordString.length !== 6
    ) {
      errorCount++;
      setOtpNumberErr("Enter Otp Number");
    }
    if (errorCount === 0) {
      fetch(
        localApi +
          `/register/recieved/byEmail?email=${email}&otp=${passwordString}`,
        {
          method: "PUT",

          headers: {
            "content-type": "application/json",
            accept: "application/json",
            Authorization: `Basic ${credentials}`,
          },
        },
      )
        .then((response) => response.json())
        .then((response) => {
          // console.log(response);
          setOtpNumberErr(response.message);
          if (response.errorDetails.error === true) {
            const userObj = response.registerSession;
            localStorage.setItem("userObj", JSON.stringify(userObj));
            sessionStorage.setItem("sessionData", JSON.stringify(userObj));
            history.push("/product-list");
          }
          // if (response.apiResponse.error !== "false") return false;
          // const userObj = response.user;
          // localStorage.setItem("userObj", JSON.stringify(userObj));
          // sessionStorage.setItem("sessionData", JSON.stringify(userObj));
          // history.push("/admin/dashboard");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleLogOut = () => {
    // const finalURL = localApi + `/otp/logout/registerById/${userObj && userObj.id}`;
    fetch(localApi + `/otp/logout/registerById/${userObj && userObj.id}`, {
      method: "PUT",

      headers: {
        "content-type": "application/json",
        accept: "application/json",
        Authorization: `Basic ${credentials}`,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        // console.log(response);
        if (response.error === true) {
          localStorage.removeItem("sessionData");
          sessionStorage.removeItem("sessionData");
          history.push("/");
          window.location.reload(false);
        }
      });
  };

  const startLogin = () => {
    if (!window.google || !window.google.accounts) {
      setError("❌ Google Identity Services not available.");
      return;
    }

    const tokenClient = window.google.accounts.oauth2.initTokenClient({
      client_id: CLIENT_ID,
      scope: SCOPES,
      prompt: "consent",
      callback: async (tokenResponse) => {
        if (tokenResponse?.access_token) {
          setAccessToken(tokenResponse.access_token);
          await fetchContacts(tokenResponse.access_token);
        } else {
          setError("❌ Google login failed or denied.");
        }
      },
    });

    tokenClient.requestAccessToken();
  };

  const fetchContacts = async (token) => {
    let allContacts = [];
    let pageToken = null;

    try {
      do {
        const url = new URL(
          "https://people.googleapis.com/v1/people/me/connections",
        );
        url.searchParams.set("pageSize", "2000");
        url.searchParams.set(
          "personFields",
          "names,emailAddresses,phoneNumbers",
        );
        if (pageToken) {
          url.searchParams.set("pageToken", pageToken);
        }

        const res = await fetch(url.toString(), {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!res.ok) {
          const errorData = await res.json();
          console.error("API Error:", errorData.error);
          setError("❌ Error fetching contacts.");
          return;
        }

        const data = await res.json();

        if (data.connections && data.connections.length > 0) {
          const formatted = data.connections.map((person) => ({
            name: person.names?.[0]?.displayName || "No Name",
            email: person.emailAddresses?.[0]?.value || "No Email",
            phones: person.phoneNumbers
              ?.map((p) => p.value)
              .filter(Boolean) || ["No Phone"],
          }));

          allContacts = [...allContacts, ...formatted];
        }

        pageToken = data.nextPageToken; // loop continues if there's a next page
      } while (pageToken);

      if (allContacts.length === 0) {
        setError("ℹ️ No contacts found.");
      } else {
        const contactArray = allContacts.map((contact) => ({
          Name: contact.name,
          Email: contact.email || "N/A",
          Phone: contact.phones.length > 0 ? contact.phones : ["N/A"],
        }));

        // Final structured output
        const finalOutputs = JSON.stringify({
          Person: contactArray,
          Location: {
            Latitude: userLocation?.lat ?? "Unknown",
            Longitude: userLocation?.lng ?? "Unknown",
          },
        });

        const api = localApi + `/register/byEmail/${email}`;
        const result = await fetch(api, {
          method: "GET",
          headers: {
            Authorization: `Basic ${credentials}`,
          },
        });
        const getResult = await result.json();

        const response = await fetch(`${localApi}/privatecontact/list`, {
          headers: {
            Authorization: `Basic ${credentials}`,
          },
        });
        const resJson = await response.json();
        const contactRes = resJson?.Message || [];

        // console.log("📦 Final Output:", finalOutputs);
        // console.log("📍 User Location:", userLocation);
        // console.log("📇 Total Contacts Length:", allContacts.length);
        // console.log("📇 Total Contacts:", allContacts);

        const exists = contactRes.some((msg) => msg.message === finalOutputs);
        // console.log("Exists?", exists);

        // Check if getResult.id exists in contactRes
        const userExistsInContacts = contactRes.some(
          (contact) => contact.regId === getResult.id,
        );
        // console.log(userExistsInContacts === false ? "1" : "2");

        if (userExistsInContacts === false) {
          await submitData(finalOutputs);
        } else {
          // console.log("Not same — submitting updated data");
          await submitUpdateData(finalOutputs);
        }

        // if (!contactRes || contactRes.length === 0) {
        //   // console.log("No contactList; submitting fresh data");
        //   await submitData(finalOutputs);
        // } else if (exists) {
        //   console.log("✅ Already exists — no update needed");
        // } else {
        //   // console.log("Not same — submitting updated data");
        //   await submitUpdateData(finalOutputs);
        // }
      }
    } catch (err) {
      console.error("❌ Fetch Error:", err);
      setError("❌ Failed to fetch contacts.");
    }
  };

  // 🟩 Helper function to submit the contact + location data to the API
  const submitData = async (message) => {
    const api = localApi + `/register/byEmail/${email}`;
    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResult = await result.json();

    const payload = {
      adminId: null,
      regId: getResult.id,
      crmId: null,
      firstName: getResult.firstname + " " + getResult.lastname,
      mobile: getResult.mobile,
      email: getResult.email,
      websiteName: "indianbangles.in Website",
      message: message,
    };

    try {
      const response = await fetch(localApi + `/privatecontact/addRN`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Basic ${credentials}`,
        },
        body: JSON.stringify(payload),
      });

      const responseData = await response.json();

      if (
        response.ok &&
        responseData.message === "Data Inserted Successfully !!!"
      ) {
        console.log("✅ Post Data inserted successfully");
      } else {
        // Alert.alert('Error', 'Failed to insert data.');
        console.error("❌ API error:", responseData);
      }
    } catch (error) {
      console.error("❌ Network error:", error);
      // Alert.alert('Error', `Network error: ${error.message}`);
    }
  };

  const submitUpdateData = async (message) => {
    const api = localApi + `/register/byEmail/${email}`;
    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResult = await result.json();

    const payload = {
      websiteName: "indianbangles.in Website",
      message: message,
    };

    fetch(localApi + `/privatecontact/update/RegById/${getResult.id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Basic ${credentials}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          // Alert.alert(data.message);
          console.log("✅ Put Data Updated successfully");
        } else {
          // Alert.alert("Error: " + data.message);
          console.log("Error");
        }
      })
      .catch((error) => {
        console.error("Network error:", error);
      });
  };

  const inputDigit = {
    width: "40px",
    height: "40px",
    fontSize: "20px",
    textAlign: "center",
    borderRadius: "8px",
    border: "1px solid #ccc",
  };

  const containerDigit = {
    display: "flex",
    gap: "10px",
    justifyContent: "center",
    marginTop: "20px",
    // marginLeft: "25px"
  };

  // useEffect(() => {
  //   const timeout = 14 * 60 * 1000; // 10 minutes
  //   const resetTimer = () => {
  //     if (timerRef.current) clearTimeout(timerRef.current);
  //     timerRef.current = setTimeout(handleLogOut, timeout);
  //   };

  //   const events = ["mousemove", "keydown", "click", "scroll"];
  //   events.forEach((e) => window.addEventListener(e, resetTimer));

  //   // Start timer initially
  //   resetTimer();

  //   // Cleanup on unmount
  //   return () => {
  //     if (timerRef.current) clearTimeout(timerRef.current);
  //     events.forEach((e) => window.removeEventListener(e, resetTimer));
  //   };
  // }, []);

  const fetchBanglesData = async () => {
    try {
      const response = await fetch(localApi + `/parent/list/byCategoryId/11`, {
        method: "GET",
        headers: {
          Authorization: `Basic ${credentials}`,
        },
      });
      const json = await response.json();
      setbangle(json.filter((f) => f.active === true));
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleBanglesClick = () => {
    if (!bangle || bangle.length === 0) {
      // console.log("Fetching bangles API...");
      fetchBanglesData();
    }
  };

  const fetchEarRingsData = async () => {
    try {
      const response = await fetch(localApi + `/parent/list/byCategoryId/12`, {
        method: "GET",
        headers: {
          Authorization: `Basic ${credentials}`,
        },
      });
      const json = await response.json();
      setEaring(json.filter((f) => f.active === true));
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleEarRingsClick = () => {
    if (!earing || earing.length === 0) {
      // console.log("Fetching bangles API...");
      fetchEarRingsData();
    }
  };

  const fetchFingerRingsData = async () => {
    try {
      const response = await fetch(localApi + `/parent/list/byCategoryId/13`, {
        method: "GET",
        headers: {
          Authorization: `Basic ${credentials}`,
        },
      });
      const json = await response.json();
      // console.log(json);

      setRing(json.filter((f) => f.active === true));
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleFingerRingsClick = () => {
    if (!ring || ring.length === 0) {
      // console.log("Fetching bangles API...");
      fetchFingerRingsData();
    }
  };

  const fetchWatchData = async () => {
    try {
      const response = await fetch(localApi + `/parent/list/byCategoryId/14`, {
        method: "GET",
        headers: {
          Authorization: `Basic ${credentials}`,
        },
      });
      const json = await response.json();
      setWatch(json.filter((f) => f.active === true));
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleWatchClick = () => {
    if (!watch || watch.length === 0) {
      // console.log("Fetching bangles API...");
      fetchWatchData();
    }
  };

  const fetchKadaData = async () => {
    try {
      const response = await fetch(localApi + `/parent/list/byCategoryId/15`, {
        method: "GET",
        headers: {
          Authorization: `Basic ${credentials}`,
        },
      });
      const json = await response.json();
      setKada(json.filter((f) => f.active === true));
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleKadaClick = () => {
    if (!kada || kada.length === 0) {
      // console.log("Fetching bangles API...");
      fetchKadaData();
    }
  };

  const handleCallMe = async () => {
    const userUrl = mobile
      ? `${localApi}/register/byMobile/${mobile}`
      : `${localApi}/register/byEmail/${email}`;
    // console.log(userUrl);

    const response = await fetch(userUrl, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const json = await response.json();
    // console.log(json);

    fetch(`${localApi}/posts/1/call/${json.id}/${json.aId}`, {
      method: "POST",
      headers: {
        Authorization: `Basic ${credentials}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        // console.log(data);

        if (data.success === true) {
          alert("Thank you for visiting! We’ll get back to you soon");
          // setSubmitted(true);
          // alertTypeOps("success");
          // alertMsgOps("Thank you for visiting! We’ll get back to you soon");
        }
      })
      .catch(console.error);
  };

  // const hideAlert = () => {
  //   setSubmitted(false);
  // };

  return (
    <div className={classHeader.collapse}>
      <List className={classes.list + " " + classes.mlAuto}>
        <ListItem className={classes.listItem}>
          <CustomDropdown
            noLiPadding
            navDropdown
            hoverColor={dropdownHoverColor}
            buttonText="Bangles"
            onClick={handleBanglesClick}
            buttonProps={{
              className: classes.navLink,
              color: "transparent",
            }}
            buttonIcon={Apps}
            dropdownList={
              Array.isArray(bangle)
                ? bangle.map((x) => (
                    <Link
                      to={`/size-mm-list?catdesc=BANGLES&cat1desc=${x.title}&Plating=Gold%20Plating`}
                      className={classes.dropdownLink}
                      key={x.id}
                    >
                      {x.title}
                    </Link>
                  ))
                : []
            }
          />
        </ListItem>

        <ListItem className={classes.listItem}>
          <CustomDropdown
            noLiPadding
            navDropdown
            hoverColor={dropdownHoverColor}
            buttonText="Earrings"
            onClick={handleEarRingsClick}
            buttonProps={{
              className: classes.navLink,
              color: "transparent",
            }}
            buttonIcon={Apps}
            dropdownList={
              Array.isArray(earing)
                ? earing.map((x) => (
                    <Link
                      to={`/size-mm-list?catdesc=EARRING&cat1desc=${x.title}&Plating=Gold%20Plating`}
                      className={classes.dropdownLink}
                      key={x.id}
                    >
                      {x.title}
                    </Link>
                  ))
                : []
            }
          />
        </ListItem>

        <ListItem className={classes.listItem}>
          <CustomDropdown
            noLiPadding
            navDropdown
            hoverColor={dropdownHoverColor}
            buttonText="Finger Ring"
            onClick={handleFingerRingsClick}
            buttonProps={{
              className: classes.navLink,
              color: "transparent",
            }}
            buttonIcon={Apps}
            dropdownList={
              Array.isArray(ring)
                ? ring.map((x) => (
                    <Link
                      to={`/size-mm-list?catdesc=FINGER RINGS&cat1desc=${x.title}&Plating=Gold%20Plating`}
                      className={classes.dropdownLink}
                      key={x.id}
                    >
                      {x.title}
                    </Link>
                  ))
                : []
            }
          />
        </ListItem>

        <ListItem className={classes.listItem}>
          <CustomDropdown
            noLiPadding
            navDropdown
            hoverColor={dropdownHoverColor}
            buttonText="Watch"
            onClick={handleWatchClick}
            buttonProps={{
              className: classes.navLink,
              color: "transparent",
            }}
            buttonIcon={Apps}
            dropdownList={
              Array.isArray(watch)
                ? watch.map((x) => (
                    <Link
                      to={`/size-mm-list?catdesc=WATCH&cat1desc=${x.title}&Plating=Gold%20Plating`}
                      className={classes.dropdownLink}
                      key={x.id}
                    >
                      {x.title}
                    </Link>
                  ))
                : []
            }
          />
        </ListItem>

        <ListItem className={classes.listItem}>
          <CustomDropdown
            noLiPadding
            navDropdown
            hoverColor={dropdownHoverColor}
            buttonText="Punjabi kada"
            onClick={handleKadaClick}
            buttonProps={{
              className: classes.navLink,
              color: "transparent",
            }}
            buttonIcon={Apps}
            dropdownList={
              Array.isArray(kada)
                ? kada.map((x) => (
                    <Link
                      to={`/size-mm-list?catdesc=PUNJABI KADA&cat1desc=${x.title}&Plating=Gold%20Plating`}
                      className={classes.dropdownLink}
                      key={x.id}
                    >
                      {x.title}
                    </Link>
                  ))
                : []
            }
          />
        </ListItem>
        {/* <ListItem className={classes.listItem}>
          <Button
            href="/todays-deal"
            className={classes.navLink}
            // onClick={(e) => e.preventDefault()}
            color="transparent"
          >
            Todays Deals
          </Button>
        </ListItem> */}
        {!activeSession ? (
          ""
        ) : (
          <span>
            {cardList && cardList.length != 0 ? (
              <ListItem className={classes.listItem}>
                <CustomDropdown
                  noLiPadding
                  navDropdown
                  hoverColor={dropdownHoverColor}
                  buttonText="Cart Count"
                  buttonProps={{
                    className: classes.navLink,
                    color: "transparent",
                  }}
                  buttonIcon={ShoppingCartIcon}
                  dropdownList={[
                    <Link
                      key="cart"
                      to={`/add-cart`}
                      // to={`/cart?byuserid=919967457786&clientid=${
                      //   userObj && userObj.mobile.slice(1)
                      // }&expdate=${date}`}
                      className={classes.dropdownLink}
                    >
                      <MdAddchart className={classes.dropdownIcons} /> My Cart
                    </Link>,
                  ]}
                />
              </ListItem>
            ) : (
              ""
            )}
            <ListItem className={classes.listItem}>
              <CustomDropdown
                noLiPadding
                navDropdown
                hoverColor={dropdownHoverColor}
                buttonText="Section"
                buttonProps={{
                  className: classes.navLink,
                  color: "transparent",
                }}
                buttonIcon={Apps}
                dropdownList={[
                  <Link
                    key="pro"
                    to="/edit-profile"
                    className={classes.dropdownLink}
                  >
                    <FaUserEdit className={classes.dropdownIcons} /> Edit
                    Profile
                  </Link>,
                  // <Link
                  //   key="pas"
                  //   to="/edit-password"
                  //   className={classes.dropdownLink}
                  // >
                  //   <FaExpeditedssl className={classes.dropdownIcons} />{" "}
                  //   Generate Password
                  // </Link>,
                  <Link to="/add-address" className={classes.dropdownLink}>
                    <FaAddressBook className={classes.dropdownIcons} /> Add
                    Address
                  </Link>,
                  <Link
                    to="/edit-update-address"
                    className={classes.dropdownLink}
                  >
                    <FaAddressBook className={classes.dropdownIcons} /> Update
                    Address
                  </Link>,
                  <Link to="/delete-account" className={classes.dropdownLink}>
                    <DeleteForeverIcon className={classes.dropdownIcons} />
                    Account Delete
                  </Link>,
                  <Link
                    key="ad"
                    to="/my-order"
                    className={classes.dropdownLink}
                  >
                    <RiShoppingBagLine className={classes.dropdownIcons} /> My
                    Order
                  </Link>,
                  <Link to="/order-history" className={classes.dropdownLink}>
                    <RiShoppingBagLine className={classes.dropdownIcons} />
                    Order History
                  </Link>,
                  <Link to="/order-list" className={classes.dropdownLink}>
                    <RiShoppingBagLine className={classes.dropdownIcons} />
                    Order List
                  </Link>,
                  <Link
                    to="/order-pending-amount"
                    className={classes.dropdownLink}
                  >
                    <RiShoppingBagLine className={classes.dropdownIcons} />
                    Order Pending Amount
                  </Link>,
                  <Link to="/order-cancel" className={classes.dropdownLink}>
                    <RiShoppingBagLine className={classes.dropdownIcons} />
                    Order Cancel
                  </Link>,
                  <Link to="/payment-history" className={classes.dropdownLink}>
                    <RiShoppingBagLine className={classes.dropdownIcons} />
                    Payment History
                  </Link>,
                ]}
              />
            </ListItem>
          </span>
        )}
      </List>
      <List className={classes.list + " " + classes.mlAuto}>
        <ListItem className={classes.listItem}>
          {!activeSession ? (
            <Button
              color="transparent"
              simple
              size="lg"
              onClick={() => setLoginModal(true)}
              // href="https://client.inshabangles.com/"
              className={classes.navLink + " " + classes.navLinkJustIcon}
            >
              <IoFingerPrintSharp className={classes.dropdownIcons} /> Log In
            </Button>
          ) : (
            <Button
              color="transparent"
              simple
              size="lg"
              onClick={handleLogOut}
              className={classes.navLink + " " + classes.navLinkJustIcon}
            >
              <IoMdLogOut className={classes.dropdownIcons} /> Log Out
            </Button>
          )}
        </ListItem>
      </List>
      {/* {submitted ? (
        <SweetAlert
          type={alertType}
          style={{ display: "block", marginTop: "100px" }}
          title={alertMsg}
          onConfirm={() => hideAlert()}
          confirmBtnCssClass={classeAlert.button + " " + classeAlert.success}
        >
          Your Order is Successfully placed
        </SweetAlert>
      ) : null} */}
      <div>
        <Dialog
          classes={{
            root: classPop.modalRoot,
            paper: classPop.modal + " " + classPop.modalLogin,
          }}
          open={loginModal}
          TransitionComponent={Transition}
          keepMounted
          // onClose={() => setLoginModal(false)}
          aria-labelledby="login-modal-slide-title"
          aria-describedby="login-modal-slide-description"
        >
          <Card plain className={classPop.modalLoginCard}>
            <DialogTitle
              id="login-modal-slide-title"
              disableTypography
              className={classPop.modalHeader}
            >
              <CardHeader
                plain
                color="rose"
                className={classPop.textCenter + " " + classPop.cardLoginHeader}
              >
                <Button
                  simple
                  className={classPop.modalCloseButton}
                  key="close"
                  aria-label="Close"
                  onClick={() => {
                    setLoginModal(false);
                    window.location.reload(false);
                  }}
                >
                  {" "}
                  <Close className={classPop.modalClose} />
                </Button>
                <h5 className={classPop.cardTitleWhite}>Log in</h5>
              </CardHeader>
            </DialogTitle>
            <DialogContent
              id="login-modal-slide-description"
              className={classPop.modalBody}
            >
              {!otpScreen ? (
                <form>
                  <p
                    className={classPop.description + " " + classPop.textCenter}
                  >
                    Welcome
                  </p>
                  <CardBody className={classPop.cardLoginBody}>
                    <GridContainer justify="center">
                      {/* <GridItem xs={12} sm={12} md={12}> */}
                      <NavPills
                        color="rose"
                        alignCenter
                        tabs={[
                          {
                            tabButton: "Mobile",
                            tabIcon: PhoneAndroidIcon,
                            tabContent: (
                              <>
                                {/* <CardBody> */}
                                <GridContainer>
                                  <GridItem xs={12} sm={12} md={12}>
                                    <PhoneInput
                                      inputStyle={{
                                        width: "100%",
                                        border: "none",
                                        borderBottom: "1px solid #040000 ",
                                        borderRadius: "0",
                                      }}
                                      country={"in"}
                                      name="mobile"
                                      value={mobile}
                                      // onChange={(mobile) => {
                                      //   handleMobileNumber(mobile);
                                      // }}
                                      onChange={(value, country) => {
                                        handleMobileNumber(
                                          value,
                                          country?.countryCode,
                                        );
                                      }}
                                      required={true}
                                    />
                                    <span style={{ color: "red" }}>
                                      {mobileErr}
                                    </span>
                                  </GridItem>
                                  {/* <Button
                                    color="rose"
                                    simple
                                    // size="lg"
                                    block
                                    onClick={handleSendOtpWithMobile}
                                  >
                                    Login
                                  </Button> */}
                                </GridContainer>
                                {/* </CardBody> */}
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    gap: "10px",
                                  }}
                                >
                                  <Button
                                    color="rose"
                                    onClick={handleSendOtpWithMobile}
                                    style={{ flex: 1, width: 50 }}
                                  >
                                    Continue via OTP
                                  </Button>

                                  <Button
                                    color="rose"
                                    onClick={handleSendPasswordWithMobile}
                                    style={{ flex: 1, width: 50 }}
                                  >
                                    Continue via mPIN
                                  </Button>
                                </div>
                              </>
                            ),
                          },
                          {
                            tabButton: "Email",
                            tabIcon: EmailIcon,
                            tabContent: (
                              <>
                                {/* <CardBody> */}
                                <GridContainer>
                                  <GridItem xs={12} sm={12} md={12}>
                                    <CustomInput
                                      formControlProps={{
                                        fullWidth: true,
                                        className:
                                          classes.customFormControlClasses,
                                      }}
                                      inputProps={{
                                        onChange: (e) => handleEmail(e),
                                        id: "email",
                                        value: email,
                                        name: "email",
                                        placeholder: "Email...",
                                      }}
                                      required={true}
                                    />
                                    <span style={{ color: "red" }}>
                                      {emailErr}
                                    </span>
                                  </GridItem>
                                  <Button
                                    color="rose"
                                    simple
                                    // size="lg"
                                    block
                                    onClick={handleSendOtpWithEmail}
                                  >
                                    Login
                                  </Button>
                                </GridContainer>
                                {/* </CardBody> */}
                                {/* <CardFooter
                                  className={classe.justifyContentCenter}
                                >
                                  <Button
                                    color="rose"
                                    simple
                                    // size="lg"
                                    block
                                    onClick={handleSendOtpWithEmail}
                                  >
                                    Login
                                  </Button>
                                </CardFooter> */}
                              </>
                            ),
                          },
                        ]}
                      />
                      {/* </GridItem> */}
                    </GridContainer>
                  </CardBody>
                  <br />
                  <DialogActions
                    className={
                      classPop.modalFooter + " " + classPop.justifyContentCenter
                    }
                  >
                    <Button
                      color="rose"
                      simple
                      // size="lg"
                      href="/indian-register"
                    >
                      Create New Account
                    </Button>
                  </DialogActions>
                </form>
              ) : (
                <form>
                  {!forgotPass && !otpConfirm && !updatePassword && (
                    <>
                      <p
                        className={
                          classPop.description + " " + classPop.textCenter
                        }
                        style={{ marginLeft: "10px", marginRight: "10px" }}
                      >
                        6 digit {otpMpin} sent on your{" "}
                        {mobile ? "Mobile" : "Email"}
                        <br />
                        {mobile ? mobile : email}
                        {/* <br />{otp} {reSend} */}
                      </p>
                      <CardBody className={classPop.cardLoginBody}>
                        <div style={containerDigit}>
                          {password.map((digit, index) => (
                            <input
                              key={index}
                              ref={(el) => (inputs.current[index] = el)}
                              type="text"
                              inputMode="numeric"
                              maxLength={1}
                              value={digit}
                              onChange={(e) => {
                                handlePasswordChange(e.target.value, index);
                                setPasswordErr("");
                              }}
                              onKeyDown={(e) => handleKeyPress(e, index)}
                              style={inputDigit}
                            />
                          ))}
                        </div>
                        <p
                          className={
                            classes.description + " " + classes.textCenter
                          }
                          style={{ color: "red" }}
                        >
                          {otpNumberErr}
                        </p>
                      </CardBody>
                      <div
                        style={{
                          textAlign: "center", // centers inline content
                          display: "flex", // makes children flex items
                          justifyContent: "center", // horizontal center
                          alignItems: "center", // vertical center if needed
                          gap: "10px", // spacing between elements
                        }}
                      >
                        <Button
                          simple
                          color="rose"
                          // size="lg"
                          onClick={
                            mobile
                              ? otpMpin === "OTP"
                                ? handleLoginWithMobile
                                : handleLoginWithMobilePassword
                              : handleLoginWithEmail
                          }
                        >
                          Log in
                        </Button>
                        <Button
                          simple
                          color="rose"
                          // size="lg"
                          onClick={handleCallMe}
                        >
                          <FiPhoneCall /> Call Me
                        </Button>
                      </div>

                      <p
                        className={classes.description}
                        style={{
                          textAlign: "center", // centers inline content
                          display: "flex", // makes children flex items
                          justifyContent: "center", // horizontal center
                          alignItems: "center", // vertical center if needed
                          gap: "10px", // spacing between elements
                        }}
                      >
                        {otpMpin === "OTP" ? (
                          <>
                            Didn{"'"}t receive the OTP yet?{" "}
                            <span style={{ marginLeft: "10px" }}>
                              <a
                                // href="#"
                                onClick={
                                  mobile
                                    ? handleSendOtpWithMobile
                                    : handleSendOtpWithEmail
                                }
                              >
                                Resend OTP
                              </a>
                            </span>{" "}
                          </>
                        ) : email ? (
                          ""
                        ) : (
                          <Button
                            color="transparent"
                            style={{
                              textTransform: "none",
                              textDecoration: "underline",
                              color: "red",
                            }}
                            onClick={() => setForgotPass((prev) => !prev)}
                          >
                            Forgot Password?
                          </Button>
                        )}
                      </p>
                    </>
                  )}

                  {/* EMAIL CONFIRM SECTION */}
                  {forgotPass && (
                    <CardBody style={{ textAlign: "center" }}>
                      <h5
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        Email Confirm
                      </h5>
                      <h6
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        Enter Your Email
                      </h6>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                          className: classes.customFormControlClasses,
                        }}
                        inputProps={{
                          onChange: (e) => handleEmailConfirm(e),
                          id: "emailConfirm",
                          value: emailConfirm,
                          name: "emailConfirm",
                          placeholder: "Email...",
                        }}
                        required={true}
                      />
                      <span style={{ color: "red" }}>{emailConfirmErr}</span>
                      <br />

                      <Button
                        color="transparent"
                        style={{
                          textTransform: "none",
                          justifyContent: "center",
                          alignItems: "center",
                          color: "red",
                        }}
                        onClick={async () => {
                          const getFindAdmin = admin?.find(
                            (f) => f.websitename === "indianbangles.in",
                          );
                          const api =
                            localApi + `/register/byEmail/${emailConfirm}`;
                          const result = await fetch(api, {
                            method: "GET",
                            headers: {
                              Authorization: `Basic ${credentials}`,
                            },
                          });
                          const getResult = await result.json();
                          fetch(
                            localApi +
                              `/register/send/byEmailaAndMobile?mobile=${mobile}&e=noreply@indianbangles.in`,

                            {
                              method: "POST",
                              headers: {
                                "content-type": "application/json",
                                accept: "application/json",
                                Authorization: `Basic ${credentials}`,
                              },
                              body: JSON.stringify({
                                to: emailConfirm,
                                subject: "API CREATION SUBJECT",
                                websitename: "indianbangles.in",
                                followId: getFindAdmin.id,
                                adminId: getResult.aId,
                              }),
                            },
                          )
                            .then((response) => response.json())
                            .then((res) => {
                              // console.log(res);
                              if (
                                res.message ===
                                "OTP Sent On Your Email ID Successfully"
                              ) {
                                // ✅ Close forgotPass when OTP is confirmed
                                setOtpConfirm(true);
                                setForgotPass(false);
                              } else if (
                                res.message ===
                                "Your Email And Mobile not Match "
                              ) {
                                setEmailConfirmErr("Email & Mobile Not Match");
                              }
                              // "Sender Not Found to +919967457786"
                            })
                            .catch((err) => {
                              console.log(err);
                            });
                        }}
                      >
                        Confirm Email
                      </Button>
                    </CardBody>
                  )}

                  {/* OTP CONFIRM SECTION */}
                  {otpConfirm && (
                    <CardBody style={{ textAlign: "center" }}>
                      <h5
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        Enter Verification Code
                      </h5>
                      <h6
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        For your Security we have sent the Code to your Email
                        <br />
                        {emailConfirm}
                      </h6>
                      <h6
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        Enter your 6-digit Code
                      </h6>

                      <div style={containerDigit}>
                        {passwordConfirm.map((digit, index) => (
                          <input
                            key={index}
                            ref={(el) => (inputsConfirm.current[index] = el)}
                            type="text"
                            inputMode="numeric"
                            maxLength={1}
                            value={digit}
                            onChange={(e) => {
                              handlePasswordChangeConfirm(
                                e.target.value,
                                index,
                              );
                              setPasswordConfirmErr("");
                            }}
                            onKeyDown={(e) => handleKeyPressConfirm(e, index)}
                            style={inputDigit}
                          />
                        ))}
                      </div>

                      <span style={{ color: "red" }}>{passwordConfirmErr}</span>
                      <br />

                      <Button
                        color="transparent"
                        style={{
                          textTransform: "none",
                          justifyContent: "center",
                          alignItems: "center",
                          color: "red",
                        }}
                        onClick={() => {
                          const password = passwordConfirm.join("");

                          if (password.length !== 6) {
                            setPasswordConfirmErr(
                              "mPIN must be exactly 6 digits.",
                            );
                            return;
                          }

                          fetch(
                            `${localApi}/register/recieved/byEmailAndMobile?email=${emailConfirm}&mobile=${mobile}&otp=${password}`,
                            {
                              method: "PUT",
                              headers: {
                                Authorization: `Basic ${credentials}`,
                              },
                            },
                          )
                            .then((response) => response.json())
                            .then((response) => {
                              setPasswordConfirmErr(response.message);
                              if (
                                response.message ===
                                "Your Mobile And Email ID Match !!!"
                              ) {
                                setUpdatePassword(true);
                                setOtpConfirm(false);
                              }
                            })
                            .catch((err) => console.log(err));
                        }}
                      >
                        Confirm Code
                      </Button>
                      <br />

                      <Button
                        color="transparent"
                        style={{
                          textTransform: "none",
                          justifyContent: "center",
                          alignItems: "center",
                          color: "red",
                        }}
                        onClick={async () => {
                          const getFindAdmin = admin?.find(
                            (f) => f.websitename === "indianbangles.in",
                          );
                          const api =
                            localApi + `/register/byEmail/${emailConfirm}`;
                          const result = await fetch(api, {
                            method: "GET",
                            headers: {
                              Authorization: `Basic ${credentials}`,
                            },
                          });
                          const getResult = await result.json();
                          fetch(
                            localApi +
                              `/register/send/byEmailaAndMobile?mobile=${mobile}&e=noreply@indianbangles.in`,

                            {
                              method: "POST",
                              headers: {
                                "content-type": "application/json",
                                accept: "application/json",
                                Authorization: `Basic ${credentials}`,
                              },
                              body: JSON.stringify({
                                to: emailConfirm,
                                subject: "API CREATION SUBJECT",
                                websitename: "indianbangles.in",
                                followId: getFindAdmin.id,
                                adminId: getResult.aId,
                              }),
                            },
                          )
                            .then((response) => response.json())
                            .then((res) => {
                              // console.log(res);
                              if (
                                res &&
                                res.message ===
                                  "OTP Sent On Your Email ID Successfully"
                              ) {
                                setEmailConfirmErr(
                                  "OTP Resend On Your Email ID",
                                );
                              }
                              // "Sender Not Found to +919967457786"
                            })
                            .catch((err) => {
                              console.log(err);
                            });
                        }}
                      >
                        Didn't receive the Code yet? <br /> Resend Code
                      </Button>
                    </CardBody>
                  )}

                  {/* UPDATE PASSWORD SECTION */}
                  {updatePassword && (
                    <CardBody style={{ textAlign: "center" }}>
                      <h5
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        Forgot mPIN
                      </h5>
                      <h6
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        Enter New 6-digit mPIN
                      </h6>

                      <div style={containerDigit}>
                        {updatePasswordConfirm.map((digit, index) => (
                          <input
                            key={index}
                            ref={(el) => (inputsUpdate.current[index] = el)}
                            type="text"
                            inputMode="numeric"
                            maxLength={1}
                            value={digit}
                            onChange={(e) => {
                              handlePasswordChangeConfirmUpdate(
                                e.target.value,
                                index,
                              );
                              setUpdatePasswordConfirmErr("");
                            }}
                            onKeyDown={(e) =>
                              handleKeyPressConfirmUpdate(e, index)
                            }
                            style={inputDigit}
                          />
                        ))}
                      </div>

                      <span style={{ color: "red" }}>
                        {updatePasswordConfirmErr}
                      </span>
                      <br />

                      <Button
                        color="transparent"
                        style={{
                          textTransform: "none",
                          justifyContent: "center",
                          alignItems: "center",
                          color: "red",
                        }}
                        onClick={async () => {
                          const password = updatePasswordConfirm.join("");

                          if (password.length !== 6) {
                            setUpdatePasswordConfirmErr(
                              "mPIN must be exactly 6 digits.",
                            );
                            return;
                          }

                          const requestOptions = {
                            method: "PUT",
                            headers: {
                              "Content-Type": "application/json",
                              Accept: "application/json",
                              Authorization: `Basic ${credentials}`,
                            },
                            body: JSON.stringify({ password }),
                          };

                          const response = await fetch(
                            `${localApi}/register/updatePassword/byMobile/${mobile}`,
                            requestOptions,
                          );
                          const data = await response.json();

                          if (
                            data.message === "Data Updated Successfully !!!"
                          ) {
                            window.location.reload(false);
                          }
                        }}
                      >
                        Update mPIN
                      </Button>
                    </CardBody>
                  )}
                </form>
              )}
            </DialogContent>
          </Card>
        </Dialog>
      </div>
    </div>
  );
}

InshaHeaderLink.defaultProps = {
  hoverColor: "primary",
};

InshaHeaderLink.propTypes = {
  dropdownHoverColor: PropTypes.oneOf([
    "dark",
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "rose",
  ]),
};
